import { render, staticRenderFns } from "./BookingInventoryProductDetails.vue?vue&type=template&id=5cfc57a5&scoped=true&"
import script from "./BookingInventoryProductDetails.vue?vue&type=script&lang=js&"
export * from "./BookingInventoryProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingInventoryProductDetails.vue?vue&type=style&index=0&id=5cfc57a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc57a5",
  null
  
)

export default component.exports